import cx from 'classnames';

import { createTwoDimensionalArray } from '@popularKeyword/common-utils';

import KeywordColumn from '@/components/common/KeywordRanking/KeywordColumn';

import { useSearchParams } from '@popularKeyword/common-hooks';

type KeywordRankingProps = {
  keywordRankingData: any;
  isCategoryKeyword?: boolean;
};

const KeywordRanking = ({ keywordRankingData, isCategoryKeyword = false }: KeywordRankingProps) => {
  const params = useSearchParams();
  const { type } = params;

  const data = createTwoDimensionalArray(keywordRankingData, type);

  if (!data?.length === 0) return null;

  const isLastList = data?.length < 4;

  return (
    <div className={cx('keyword-ranking__list', isLastList && 'keyword-ranking__list--end')}>
      {data.map((item, idx) => (
        <KeywordColumn isCategoryKeyword={isCategoryKeyword} data={item} key={`keywordColumn-${idx}`} />
      ))}
    </div>
  );
};

export default KeywordRanking;
